<ul class="thead text">
    <li>{{ "alarm.table.header.channelNumber" | translate }}</li>
    <li>{{ "alarm.table.header.alarmItem" | translate }}</li>
    <li>{{ "alarm.table.header.status" | translate }}</li>
    <li>{{ "alarm.table.header.value" | translate }}</li>
    <li>{{ "alarm.table.header.category" | translate }}</li>
    <li class="icon-flex th-date">
        <div>{{ "alarm.table.header.occurence" | translate }}</div>
        <div
            (click)="onOccurrenceTimeSortClicked()"
            class="icon sort"
            [ngClass]="sort"
        ></div>
    </li>
    <li class="update-time th-date">
        {{ "alarm.table.header.update" | translate }}
    </li>
    <li class="table-icon">
        <mat-icon
            class="reset-btn"
            svgIcon="refresh"
            (click)="emitRefresh()"
            *ngIf="showRefresh"
        ></mat-icon>
        <img
            class="sort-btn"
            src="assets/icons/sort.svg"
            (click)="onOccurrenceTimeSortClicked()"
        />
    </li>
</ul>
